export const FOLDER_LIST_REQUEST = 'FOLDER_LIST_REQUEST';

export const FILE_LIST_REQUEST = 'FILE_LIST_REQUEST';
